import { render, staticRenderFns } from "./VCustomCard.vue?vue&type=template&id=9db0c9c8"
import script from "./VCustomCard.vue?vue&type=script&lang=js"
export * from "./VCustomCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports